var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer has-background-white"},[_c('div',{staticClass:"content has-text-centered"},[_c('p',[_vm._v(" "+_vm._s(_vm.$t('copyright'))+" "+_vm._s(_vm.year)+" "),_c('font-awesome-icon',{attrs:{"icon":"copyright"}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }